import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {hasCommonProps} from "../../../../utils/Util";
import {defaultState as generalProps} from "./MemberGeneral";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

export const defaultState = {
    Foreningsnr: '',
    Sektionsnr: '',
    Navn: '',
    Kommune: '',
    Adresse: '',
    Postnr: '',
    Tlf: '',
    Email: '',
    Stiftet: '',
    WebSite: '',
    Bank: '',
    Regnr: '',
    Kontonr: '',
    KoerselKm: '',
    TaurisVersion: '',
};

class ClubGeneral extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        club: PropTypes.object,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.club === null && this.props.club !== null) || (nextProps.club !== null && (this.props.club === null || this.props.club.Foreningsnr !== nextProps.club.Foreningsnr)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.club === null)
            return defaultState;
        else {
            const club = props.club;
            const updateReq = club.UpdateRequests.find(req => req.type === 'club') || null;
            const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
            return {
                Foreningsnr: isUndefined(updates.Foreningsnr) ? (club.Foreningsnr === null ? '' : club.Foreningsnr) : (updates.Foreningsnr === null ? '' : updates.Foreningsnr),
                Sektionsnr: isUndefined(updates.Sektionsnr) ? (club.Sektionsnr === null ? '' : club.Sektionsnr) : (updates.Sektionsnr === null ? '' : updates.Sektionsnr),
                Navn: isUndefined(updates.Navn) ? (club.Navn === null ? '' : club.Navn) : (updates.Navn === null ? '' : updates.Navn),
                Kommune: isUndefined(updates.Kommune) ? (club.Kommune === null ? '' : club.Kommune) : (updates.Kommune === null ? '' : updates.Kommune),
                Adresse: isUndefined(updates.Adresse) ? (club.Adresse === null ? '' : club.Adresse) : (updates.Adresse === null ? '' : updates.Adresse),
                Postnr: isUndefined(updates.Postnr) ? (club.Postnr === null ? '' : club.Postnr) : (updates.Postnr === null ? '' : updates.Postnr),
                Tlf: isUndefined(updates.Tlf) ? (club.Tlf === null ? '' : club.Tlf) : (updates.Tlf === null ? '' : updates.Tlf),
                Email: isUndefined(updates.Email) ? (club.Email === null ? '' : club.Email) : (updates.Email === null ? '' : updates.Email),
                Stiftet: isUndefined(updates.Stiftet) ? (club.Stiftet === null ? '' : moment(club.Stiftet).format(config.formats.dateFormat)) : (updates.Stiftet === null ? '' : moment(updates.Stiftet).format(config.formats.dateFormat)),
                WebSite: isUndefined(updates.WebSite) ? (club.WebSite === null ? '' : club.WebSite) : (updates.WebSite === null ? '' : updates.WebSite),
                Bank: isUndefined(updates.Bank) ? (club.Bank === null ? '' : club.Bank) : (updates.Bank === null ? '' : updates.Bank),
                Regnr: isUndefined(updates.Regnr) ? (club.Regnr === null ? '' : club.Regnr) : (updates.Regnr === null ? '' : updates.Regnr),
                Kontonr: isUndefined(updates.Kontonr) ? (club.Kontonr === null ? '' : club.Kontonr) : (updates.Kontonr === null ? '' : updates.Kontonr),
                KoerselKm: isUndefined(updates.KoerselKm) ? (club.KoerselKm === null ? '' : String(club.KoerselKm)) : (updates.KoerselKm === null ? '' : String(updates.KoerselKm)),
                TaurisVersion: isUndefined(updates.TaurisVersion) ? (club.TaurisVersion === null ? '' : String(club.TaurisVersion)) : (updates.TaurisVersion === null ? '' : String(updates.TaurisVersion)),
            }
        }
    }

    fields = [];
    render() {
        const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
        const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);
        const editMode = this.props.editMode;
        return <div className={"form-page club-general " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table">
                <tbody>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated")}><span className="label-text"><label htmlFor="Foreningsnr">Foreningsnr</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Foreningsnr) ? "" : " updated")}>
                            {editMode && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[0] = instance; }}
                            /> : <span className="value-text">{this.state.Foreningsnr}</span>}
                            {isUndefined(updates.Foreningsnr) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Foreningsnr) + ')'}</span>
                            ]}
                        </td>
                        <td className={"label-cell" + (isUndefined(updates.Sektionsnr) ? "" : " updated")}><span className="label-text"><label htmlFor="Sektionsnr">Sektionsnr</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Sektionsnr) ? "" : " updated")}>
                            {editMode && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="Sektionsnr" id="Sektionsnr" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.Sektionsnr}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-200px', zIndex: 99999}}}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[1] = instance; }}
                            /> : <span className="value-text">{this.state.Sektionsnr}</span>}
                            {isUndefined(updates.Sektionsnr) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Sektionsnr) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Navn) ? "" : " updated")}><span className="label-text"><label htmlFor="Navn">Foreningsnavn</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Navn) ? "" : " updated")} colSpan={3}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="Navn" id="Navn" maxLength="17" value={this.state.Navn}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          /*errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-200px', zIndex: 99999}}}*/
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[2] = instance; }}
                            /> : <span className="value-text">{this.state.Navn}</span>}
                            {isUndefined(updates.Navn) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Navn) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Kommune) ? "" : " updated")}><span className="label-text"><label htmlFor="Kommune">Kommune</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Kommune) ? "" : " updated")} colSpan={3}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="Kommune" id="Kommune" maxLength="20" value={this.state.Kommune}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[3] = instance; }}
                            /> : <span className="value-text">{this.state.Kommune}</span>}
                            {isUndefined(updates.Kommune) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Kommune) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Adresse) ? "" : " updated")}><span className="label-text"><label htmlFor="Adresse">Adresse</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Adresse) ? "" : " updated")} colSpan={3}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="Adresse" id="Adresse" maxLength="50" value={this.state.Adresse}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[4] = instance; }}
                            /> : <span className="value-text">{this.state.Adresse}</span>}
                            {isUndefined(updates.Adresse) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Adresse) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Postnr) ? "" : " updated")}><span className="label-text"><label htmlFor="Postnr">Postnr/By</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Postnr) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="Postnr" id="Postnr" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Postnr}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[5] = instance; }}
                            /> : <span className="value-text">{this.state.Postnr}</span>}
                            {isUndefined(updates.Postnr) ? null : [
                                <br key="lf"/>,
                                <span className="value-value" key="original">{'(' + formatNullable(this.props.club.Postnr) + ')'}</span>
                            ]}
                        </td>
                        <td colSpan={2}>
                            <span className="value-text">{this.props.admin.isBasicsRead && this.props.admin.zipCodes.get(this.state.Postnr) ? this.props.admin.zipCodes.get(this.state.Postnr).By : null}</span>
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Tlf) ? "" : " updated")}><span className="label-text"><label htmlFor="Tlf">Telefon</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Tlf) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                          name="Tlf" id="Tlf" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{8}"}]} value={this.state.Tlf}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[6] = instance; }}
                            /> : <span className="value-text">{this.state.Tlf}</span>}
                            {isUndefined(updates.Tlf) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Tlf) + ')'}</span>
                            ]}
                        </td>
                        <td className={"label-cell" + (isUndefined(updates.Email) ? "" : " updated")}><span className="label-text"><label htmlFor="Email">Email</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Email) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="Email" id="Email" maxLength="50" value={this.state.Email}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[7] = instance; }}
                            /> : <span className="value-text">{this.state.Email}</span>}
                            {isUndefined(updates.Email) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Email) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Stiftet) ? "" : " updated")}><span className="label-text"><label htmlFor="Stiftet">Stiftet</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Stiftet) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                          name="Stiftet" id="Stiftet" maxLength="10" value={this.state.Stiftet}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={false} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[8] = instance; }}
                            /> : <span className="value-text">{this.state.Stiftet}</span>}
                            {isUndefined(updates.Stiftet) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + (this.props.club.Stiftet === null ? formatNullable(null) : moment(this.props.club.Stiftet).format(config.formats.dateFormat)) + ')'}</span>
                            ]}
                        </td>
                        <td className={"label-cell" + (isUndefined(updates.WebSite) ? "" : " updated")}><span className="label-text"><label htmlFor="WebSite">Hjemmeside</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.WebSite) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="WebSite" id="WebSite" maxLength="50" value={this.state.WebSite}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[9] = instance; }}
                            /> : <span className="value-text">{this.state.WebSite}</span>}
                            {isUndefined(updates.WebSite) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.WebSite) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Bank) ? "" : " updated")}><span className="label-text"><label htmlFor="Bank">Bank</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Bank) ? "" : " updated")} colSpan={3}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                          name="Bank" id="Bank" maxLength="35" value={this.state.Bank}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[10] = instance; }}
                            /> : <span className="value-text">{this.state.Bank}</span>
                            }
                            {isUndefined(updates.Bank) ? null : [
                                editMode ? null : <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Bank) + ')'}</span>
                            ]
                            }
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.Regnr) ? "" : " updated")}><span className="label-text"><label htmlFor="Regnr">Reg.nr</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Regnr) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="Regnr" id="Regnr" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Regnr}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[11] = instance; }}
                            /> : <span className="value-text">{this.state.Regnr}</span>}
                            {isUndefined(updates.Regnr) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Regnr) + ')'}</span>
                            ]}
                        </td>
                        <td className={"label-cell" + (isUndefined(updates.Kontonr) ? "" : " updated")}><span className="label-text"><label htmlFor="Kontonr">Kontonr</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.Kontonr) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                          name="Kontonr" id="Kontonr" maxLength="14" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,14}"}]} value={this.state.Kontonr}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[12] = instance; }}
                            /> : <span className="value-text">{this.state.Kontonr}</span>}
                            {isUndefined(updates.Kontonr) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + formatNullable(this.props.club.Kontonr) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                    <tr className="normal-row">
                        <td className={"label-cell" + (isUndefined(updates.TaurisVersion) ? "" : " updated")}><span className="label-text"><label htmlFor="TaurisVersion">Tauris-version</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.TaurisVersion) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="TaurisVersion" id="TaurisVersion" maxLength="4" value={this.state.TaurisVersion}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[13] = instance; }}
                            /> : <span className="value-text">{this.state.TaurisVersion}</span>}
                            {isUndefined(updates.TaurisVersion) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + (this.props.club.TaurisVersion === null ? formatNullable(null) : String(this.props.club.TaurisVersion)) + ')'}</span>
                            ]}
                        </td>
                        <td className={"label-cell" + (isUndefined(updates.KoerselKm) ? "" : " updated")}><span className="label-text"><label htmlFor="KoerselKm">Kørsel KM</label></span></td>
                        <td className={"data-cell" + (isUndefined(updates.KoerselKm) ? "" : " updated")}>
                            {editMode ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                          name="KoerselKm" id="KoerselKm" maxLength="14" value={this.state.KoerselKm}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[14] = instance; }}
                            /> : <span className="value-text">{this.state.KoerselKm}</span>}
                            {isUndefined(updates.KoerselKm) ? null : [
                                <br key="lf"/>,
                                <span className="original-value" key="original">{'(' + (this.props.club.KoerselKm === null ? formatNullable(null) : String(this.props.club.KoerselKm)) + ')'}</span>
                            ]}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                Navn: this.state.Navn,
                Kommune: this.state.Kommune === '' ? null : this.state.Kommune,
                Adresse: this.state.Adresse === '' ? null : this.state.Adresse,
                Postnr: this.state.Postnr === '' ? null : this.state.Postnr,
                Tlf: this.state.Tlf === '' ? null : this.state.Tlf,
                Email: this.state.Email === '' ? null : this.state.Email,
                Stiftet: this.state.Stiftet === '' ? null : moment(this.state.Stiftet, config.formats.dateFormat).format('YYYY-MM-DD'),
                WebSite: this.state.WebSite === '' ? null : this.state.WebSite,
                Bank: this.state.Bank === '' ? null : this.state.Bank,
                Regnr: this.state.Regnr === '' ? null : this.state.Regnr,
                Kontonr: this.state.Kontonr === '' ? null : this.state.Kontonr,
                KoerselKm: this.state.KoerselKm === '' ? null : Number(this.state.KoerselKm),
                TaurisVersion: this.state.TaurisVersion === '' ? null : Number(this.state.TaurisVersion),
            };
            if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) {
                entity.Foreningsnr = this.state.Foreningsnr;
                entity.Sektionsnr = this.state.Sektionsnr === '' ? null : this.state.Sektionsnr;
            }
            if (this.props.club === null) this.props.dispatch(AdminActions.createClub(entity, onSuccess));
            else this.props.dispatch(AdminActions.updateClub(this.props.club.Foreningsnr, entity, onSuccess));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const isUndefined = value => typeof(value) === "undefined";

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isBasicsRead: state.admin.isBasicsRead,
        zipCodes: state.admin.zipCodes,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(ClubGeneral);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/subPages/ClubGeneral.js